import React from 'react';
import { getText } from '../../utils/functions';
import { useIntelliTags } from '../../utils/hooks';
import SimpleButton from '../basicComponents/SimpleButton';

function ClosedSection({
	translate,
	colors,
	portal,
	section,
	updateRouting,

	/* OPTIONAL PROPS */
	classNameDIV = 'w-full h-full px-8 md:px-30 lg:px-52 py-4 flex flex-col flex-grow space-y-12 items-center content-center justify-center',
	styleDIV,
	classNameBTN = 'md:text-xl font-bold',
	classNameIMG = 'h-72',
	styleIMG,
	classNameTEXT = 'md:text-xl',
	styleTEXT,
}) {
	/* Default values for the styles */ // className='w-
	const defaultStyleDIV = {
		backgroundColor: colors?.background,
		transition: 'all 100ms ease-in',
	};
	const defaultStyleIMG = {
	};
	const defaultStyleTEXT = {
		color: colors?.text
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleIMG = { ...defaultStyleIMG, ...styleIMG };
	const overrideStyleTEXT = { ...defaultStyleTEXT, ...styleTEXT };

	/* Intelligent tags to be swaped */
	const { applyIntelliTags } = useIntelliTags({ portal, section, translate });

	return <div
		id='CLOSED_SECTION'
		className={classNameDIV}
		style = {overrideStyleDIV}
	>
		<img
			src={portal?.config?.closedSection?.img}
			className={classNameIMG}
			style={overrideStyleIMG}
		/>
		<div
			className={classNameTEXT}
			style= {overrideStyleTEXT}
			dangerouslySetInnerHTML={{
				__html: applyIntelliTags(
					getText(portal?.config?.closedSection?.intelliTagText, translate),
				),
			}}
		/>
		<SimpleButton
			colors={colors}
			classNameTXT={classNameBTN}
			fillMode={false}
			tag={getText(portal?.config?.closedSection?.button, translate)}
			// eslint-disable-next-line no-return-assign
			onClick={() => updateRouting(portal?.config?.closedSection?.button?.value)}
		/>
	</div>;
}

export default ClosedSection;
